// File: frontend/src/components/DashboardLayout.jsx

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import VendorFooter from './VendorFooter';

const DashboardLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-[#fbfbfe] text-slate-800 flex flex-col font-sans">
      {/* Collapsible Left Sidebar */}
      <Sidebar isCollapsed={sidebarCollapsed} setIsCollapsed={setSidebarCollapsed} />

      {/* Top Fixed Header Navbar */}
      <Navbar sidebarCollapsed={sidebarCollapsed} />

      {/* Main Page Scrollable Content */}
      <main
        className={`flex-1 transition-all duration-300 p-4 sm:p-6 lg:p-8 ${
          sidebarCollapsed ? 'ml-20' : 'ml-64'
        }`}
      >
        <div className="max-w-7xl mx-auto space-y-6">
          {children}
        </div>
      </main>

      {/* Global Immutable Vendor Footer */}
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-64'}`}>
        <VendorFooter />
      </div>
    </div>
  );
};

export default DashboardLayout;
